<template>
  <div class="view">
    <transition name="vJobNo" appear>
      <div v-if="!ReportData" style="position: absolute; z-index: 999; width: 100%; height: 100%">
        <div v-if="disabled === true" class="zezhao">
          <Loading style="position:absolute;left: 50%;transform: translateX(-50%);top:50%;" />
        </div>
        <PageOne @inputJobNo="inputJobNo"></PageOne>
      </div>
    </transition>
    <div v-if="ReportData">
      <swiper :options="swiperOption" ref="mySwiper" @slideChangeTransitionStart="onSlideChange">
        <swiper-slide>
          <PageTwo :ReportData="ReportData"></PageTwo>
        </swiper-slide>
        <swiper-slide>
          <PageTen :ReportData="ReportData"></PageTen>
        </swiper-slide>
        <swiper-slide v-if="ReportData.hongHu">
          <PageEleven :ReportData="ReportData" @submitHongHu="submitHongHu"></PageEleven>
        </swiper-slide>
        <swiper-slide>           
          <PageFive :ReportData="ReportData"></PageFive>
        </swiper-slide>
        <swiper-slide>           
          <PageSix @submit="submit" :ReportData="ReportData"></PageSix>
        </swiper-slide>
      </swiper>
    </div>   
  </div>
</template>

<script>
import Loading from './Loading.vue'
import PageOne from './PageOne.vue';
import PageTwo from './PageTwo.vue';
import PageFive from './PageFive.vue';
import PageSix from './PageSix.vue';
import PageTen from './PageTen.vue';
import PageEleven from './PageEleven.vue';
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import dataApi from "@/api/data";
import viewApi from "@/api/view";
import readApi from "@/api/read";
import { getArray } from '../../utils/encourage'

export default {
    components: {
      PageOne,
      PageTwo,
      PageFive,
      PageSix,
      PageTen,
      PageEleven,
      Loading,
      swiper,
      swiperSlide,  
    },
    data() {
      return {
        ReportData:"",
        swiperOption: {
          direction: "horizontal", //水平切换选项
          height: window.innerHeight, // 高
          width: window.innerWidth, //宽
          pagination: ".swiper-pagination",
          // autoplay:{
          //   delay:3000,
          //   disableOnInteraction: false,
          // },
          effect:'fade',
          on: {
            slideChangeTransitionStart: this.onSlideChange,
          },
        },
        jishiqi: 0,
        jobNo: '',
        viewId: '',
        source: '',
        disabled: false
      }
    },
    methods: {
		onSlideChange() {
			const currentIndex = this.$refs.mySwiper.swiper.realIndex;
			switch (currentIndex) {
				case 0: 
					this.$refs.mySwiper.swiper.update()
					break;
			}
		},
		inputJobNo(jobNo) {
			if(this.disabled === true) {
				return
			}
			if(jobNo){
				this.jobNo = jobNo
				this.disabled = true
				this.getData()
			}
		},
		getData() {
			dataApi.getDataFor25January(this.jobNo).then((res) => {
				if(res.data.code === 200) {
					this.ReportData = res.data.data.data;
					// console.log(this.ReportData,'25年1月的数据')

					if (this.ReportData) {
						this.ReportData.textLab = getArray(this.ReportData.textLab);
						this.sendViewRecords();
						this.disabled = false
					} else {
						this.$message({
							message: "抱歉，暂时找不到您的学习报告！",
							type: "warning",
							center: true,
						})
						this.disabled = false
					}
					this.disabled = false
				} else {
					this.disabled = false
					this.$message({
						message: "抱歉，暂时找不到您的学习报告！",
						type: "warning",
						center: true,
					})
				}
			})
		},
		sendViewRecords() {
			if (this.jobNo) {
				let viewData = {
					jobNo: this.jobNo,
					device: this.device,
					type: 27,
					browser: this.browser,
				}
				if (this.source) {
					viewData["source"] = this.source
				}
				viewApi.view(viewData).then((res) => {
					this.viewId = res.data.data.data.id
				})
			}
		},
		getSystem() {
			var system = navigator.userAgent;
			this.ua = system;
			//判断android ios windows
			var android = system.indexOf("Android");
			var iphone = system.indexOf("iPhone");
			var ipad = system.indexOf("ipad");
			var windows = system.indexOf("windows");
			var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
			if (android !== -1) {
				// console.log("Android");
				this.device = "Android";
				// return 'android'
			}
			if (iphone !== -1 || ipad !== -1 || isMac) {
				// console.log("ios");
				this.device = "ios";
				// return 'ios'
			}
			if (windows !== -1) {
				// console.log("windows");
				this.device = "windows";
				// return 'windows'
			}
		},
		getBrowser() {
			var userAgent = navigator.userAgent
			//取得浏览器的userAgent字符串
			//判断是否Opera浏览器
			if (userAgent.indexOf("Opera") > -1) {
				return "Opera";
			}
			//判断微信浏览器
			else if (userAgent.indexOf("MicroMessenger") > -1 || userAgent.indexOf("micromessenger") > -1) {
				return "MicroMessenger";
			}
			//判断是否是QQ浏览器
			else if (userAgent.indexOf("MQQBrowser") > -1) {
				return "MQQBrowser";
			}
			//判断是否Edge浏览器
			else if (userAgent.indexOf("Edg") > -1) {
				return "Edge";
			}
			//判断是否Firefox浏览器
			else if (userAgent.indexOf("Firefox") > -1) {
				return "firefox";
			}
			// 判断是否是小米浏览器
			else if (userAgent.indexOf("MiuiBrowser") > -1) {
				return "MiuiBrowser";
			}
			//判断是否Chrome浏览器
			else if (userAgent.indexOf("Chrome") > -1) {
				return "Chrome";
			}

			//判断是否Chrome浏览器
			else if (userAgent.indexOf("360SE") > -1) {
				return "360SE";
			}

			//判断是否Safari浏览器
			else if (userAgent.indexOf("Safari") > -1) {
				return "Safari";
			}
			//判断是否IE浏览器
			else if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
				return "IE";
			} else if (userAgent.indexOf("Trident") > -1) {
				return "IE";
			}
		},
		submit(view) {
			view["id"] = this.viewId
			viewApi.update(view).then((res) => {
				if (res) {
					this.$message({
						message: "提交成功，感谢您的留言。",
						type: "success",
						center: true,
					})
				}
			})
		},
		submitHongHu(view){
			view["id"] = this.viewId;
			viewApi.update(view).then((res) => {
				if (res.data.code===200) {
					this.$message({
						message: "提交成功",
						type: "success",
						center: true,
					})
				}
			});
		},
		watchBook(bookId) {
			readApi.watchBook('2025-1-book'+bookId,this.viewId).then(res => {
				if(res) {
					return
				}
			})
		},
		valChange() {
			const view = {}
			if(this.viewId && this.jishiqi <= 80) {
				view["id"] = this.viewId
				viewApi.update(view)
				this.jishiqi = this.jishiqi + 8
			}
		}
    },
	created() {
		this.timer = setInterval(this.valChange, 8000);
		document.title = '2025年1月学习报告'
		this.browser = this.getBrowser()
		this.getSystem()

		/* 相信数据begin */
		var test = window.location.href
		let arr = test.split("?code=")
		this.code = arr[1]
		if (this.code) {
			viewApi.getJobNoByBelieve(this.code).then((res) => {
				if(res.data.code === 200) {
					this.jobNo = res.data.data.jobNo
					this.source = "相信"
					if (this.jobNo) {
						this.disabled = true
						this.getData()
					}
				}
			})
		}
		/* 相信数据end */

		/* 微信公众号begin */
		let arrGZH = test.split('?fromway=')
		let way = arrGZH[1]
		if(way === 'wxoffacc') {
			// wxoffacc表示来自微信公众号
			this.source = '微信公众号'
			console.log(this.source)
		}
		/* 微信公众号end */
	},
    mounted() {
		setTimeout(() => {
			if (this.$jobNo) {
				this.source = "富学宝典"
				this.jobNo = this.$jobNo
				if (this.jobNo) {
					this.disabled = true
					this.getData()
				}
			}
		}, 1000)
    },
    computed: {
		swiper() {
			return this.$refs.mySwiper.swiper;
		},
	},
  }
</script>

<style scoped>
.view {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	overflow: hidden;
}

.swiper-slide {
	width: 100%;
	/* line-height: 200px; */
	background: #fff;
	color: #000;
	font-size: 16px;
	/* text-align: center; */
	touch-action: none;
}

.vJobNo-enter-active {
	animation: input 0.7s;
}
.vJobNo-leave-active {
	animation: inputed 1.1s;
}
@keyframes input {
	0% {
		transform: translateX(1000px);
	}
	100% {
		transform: translateX(0px);
	}
}
@keyframes inputed {
	0% {
		transform: translateX(0px);
	}
	100% {
		transform: translateX(-1000px);
	}
}
.zezhao {
	width: 100%;
	height: 100%;
	background: #00000058;
	z-index: 1920;
	position: absolute;
}
</style>